import React from "react";
const HeaderSectionTwo = (props) =>{
    return (
        <section
        id="header_section_without_img"
        >
            <div id='in_center_re_po'>
            <p id="header_section_without_img_title">{props.title}</p>
            <p id="header_section_without_img_title_small">{props.smallTitle}<u>{props.usmallTitle}</u></p>
            </div>
      
        </section>
    )
}
export default HeaderSectionTwo;